export const uniformPayUrl = 'https://uniformpay.theuniformsolution.com'
// export const uniformPayUrl = 'https://roydaudio.com'
export const fullSteamHostedPaymentsUrl_Test = 'https://hostedpayments-ext.fullsteampay.net/js/hostedcontrols/1.0.0/fullsteam.hostedcontrols.js'
export const fullSteamHostedPaymentsUrl = 'https://hostedpayments.fullsteampay.net/js/hostedcontrols/1.0.0/fullsteam.hostedcontrols.js'

export default uniformPayUrl
